export class LeadRedirectButtonConfiguration {

  WorkOrder: { Oid: number } | null = null;

  private constructor() {
  }

  public static create = () => new LeadRedirectButtonConfiguration();

  setWorkOrderOid(value: number | null) {

    this.WorkOrder = value ? {Oid: value} : null;
    return this;

  }

}
